import API from './API.js'
import axios from 'axios'

export default class Certifications extends API {
  constructor() {
    super('cretificate')
  }
  //cretificate/student
  async student() {
    const response = await axios.get(`/cretificate/student`)
    return response.data
  }
  async CretificateStudents(params) {
    const response = await axios.get(`/cretificate/students`, { params })
    return response.data
  }
  
}
